export default __webpack_public_path__ + "static/avatar-mp-kayi-female-0-v3-detail-bbc8ef6f3449ad878cb2f14586b316a5.png";